import { Grid, Box, Card } from "@material-ui/core";

import { NatcatAnalyticsMap } from "./NatcatAnalyticsMap";
import { NatcatStatistics } from "./NatcatStatistics";
import { useEffect } from "react";
import { saveUserMonitorData } from "../util/userUtils";

export const NatcatAnalyticsPage = () => {
  useEffect(() => {
    saveUserMonitorData("NatCatAnalytics", "");
  }, []);

  return (
    <Grid style={{ marginTop: 25 }}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12}>
          <Box>
            <Card>
              <NatcatAnalyticsMap></NatcatAnalyticsMap>
            </Card>
            <NatcatStatistics></NatcatStatistics>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};
